import { render, staticRenderFns } from "./modal-qrcode-referral.vue?vue&type=template&id=35012afc&scoped=true&"
import script from "./modal-qrcode-referral.vue?vue&type=script&lang=js&"
export * from "./modal-qrcode-referral.vue?vue&type=script&lang=js&"
import style0 from "./modal-qrcode-referral.vue?vue&type=style&index=0&id=35012afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35012afc",
  null
  
)

export default component.exports